import { schema } from "normalizr";
import { FUNCTION_OF_LANGUAGE_SCHEMA } from "./index";

export default new schema.Entity(FUNCTION_OF_LANGUAGE_SCHEMA);
